import FeedbackPage from '@/components/FeedbackPage'
import { HeartIcon } from '@heroicons/react/24/outline'

export default function HealthcareIntroPage() {
  return (
    <FeedbackPage
      icon={<HeartIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.healthcareIntro.heading"
      descriptionKey="pages.onboarding.healthcareIntro.description"
    />
  )
}
